import { render } from "./Player.vue?vue&type=template&id=3acdb6b9&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=3acdb6b9&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/inclusion_score/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acdb6b9"]])

export default __exports__